import { render } from "./teaTrainStat.vue?vue&type=template&id=02b0084b&scoped=true"
import script from "./teaTrainStat.vue?vue&type=script&lang=js"
export * from "./teaTrainStat.vue?vue&type=script&lang=js"

import "./teaTrainStat.vue?vue&type=style&index=0&id=02b0084b&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b0084b"]])

export default __exports__